import React, { Component } from 'react';
import './styles.css';

class ProcurementOverviewLayout extends Component {
	render() {
		return (
			<div className="procurement-overview-layout">{this.props.children}</div>
		);
	}
}

export default ProcurementOverviewLayout;
